var exports = {
  "k": "x31de4314--25591e--container",
};

module.exports = exports;
